<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-02-29 16:17:05
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-05-13 15:48:46
 * @Description: 配合比库
 * @FilePath: \ICPSxin\src\views\platform\ICPS\basicConfig\mixForm.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div>
          <el-collapse-transition>
            <div>
              <div class="search">
                <span style="display: inline-block; margin-bottom: 10px">
                  <span style="margin-right: 12px">产品名称</span>
                  <el-input v-model="tableParam.productNamelike" style="width: 240px" placeholder="请输入" clearable />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">配合比名称</span>
                  <el-input v-model="tableParam.name" style="width: 240px" placeholder="请输入" clearable />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">站点名称</span>
                  <el-select ref="selection" v-model="tableParam.stationId" filterable>
                    <el-option v-for="item in stationIdlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">状态</span>
                  <el-select v-model="tableParam.enable" placeholder="请选择">
                    <el-option :key="2" label="禁用" :value="0"></el-option>
                    <el-option :key="1" label="启用" :value="1"></el-option>
                    <el-option :key="3" label="全部" value=""></el-option>
                  </el-select>
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), initData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div class="card_nav">
              <div>
                <el-button size="small" class="bottom_all" style="margin-left: 0" @click="addFromDate('添加')">
                  <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                  添加
                </el-button>
                <el-button size="small" style="margin-left: 10px" class="bottom_one" @click="warehouseBind()">使用仓绑定</el-button>
              </div>
            </div>
            <div v-loading="tableLoading" class="card_info" :style="{ height: screenHeight - 450 }">
              <el-table
                :header-cell-style="{ background: '#f3f6f9' }"
                :cell-style="{ borderRight: 'none' }"
                border
                stripe
                style="width: 100%"
                :height="screenHeight - 450"
                :data="tableData"
                tooltip-effect="dark"
                @selection-change="handleSelectionChange"
              >
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width" :fixed="item.fixed" :prop="item.prop" :sortable="item.sortable">
                    <template slot-scope="scope">
                      <div v-if="item.label == '操作'">
                        <el-link :underline="false" style="margin: 5px 0" type="primary" @click="updateFromDate('修改', scope.row)">修改</el-link>
                        <el-link v-if="scope.row.enable != 0" :underline="false" style="margin: 5px 5px" type="warning" @click="updateStatus(scope.row, 0)">禁用</el-link>
                        <el-link v-else :underline="false" style="margin: 5px 5px" type="warning" @click="updateStatus(scope.row, 1)">启用</el-link>
                      </div>
                      <span v-else>{{ scope.row[item.prop] || "-" }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="initData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="initData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 添加 -->
    <el-dialog :visible.sync="addDialog" width="880px" :close-on-click-modal="false" :before-close="resetRawFromDate">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="fromDate" label-width="110px">
          <el-form-item prop="name">
            <span slot="label" style="color: #ff0000">配合比名称</span>
            <el-input v-model="fromDate.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item prop="stationId">
            <span slot="label" style="color: #ff0000">站点</span>
            <el-select
              ref="selection"
              v-model="fromDate.stationId"
              filterable
              @change="
                $nextTick(() => {
                  fromDate.stationName = $refs.selection.selectedLabel;
                  getPointDetails()
                })
              "
            >
              <el-option v-for="item in stationIdlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="strengthGradeId">
            <span slot="label" style="color: #ff0000">强度等级</span>
            <!-- <el-select v-model="fromDate.strengthGradeArr" multiple placeholder="请选择" @change="$forceUpdate()">
              <el-checkbox v-model="checked1" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll1">全选</el-checkbox>
              <el-option v-for="item in strengthGradeList" :key="item.id" :label="item.name" :value="item.id" @click.native="setStrength(item)"></el-option>
            </el-select> -->
            <el-select v-model="fromDate.strengthGradeId" filterable placeholder="请选择" @change="$forceUpdate()">
              <el-option v-for="item in strengthGradeList" :key="item.id" :label="item.name" :value="item.id" @click.native="setStrength(item)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">性能等级</span>
            <el-select v-model="fromDate.performanceRateArr" multiple filterable placeholder="请选择" @change="setPerform">
              <el-checkbox v-model="checked2" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll2">全选</el-checkbox>
              <el-option v-for="item in performanceGradeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">材料要求</span>
            <el-select v-model="fromDate.materialRequirementsArr" multiple filterable placeholder="请选择" @change="setMaterial">
              <el-checkbox v-model="checked3" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll3">全选</el-checkbox>
              <el-option v-for="item in materialRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">特殊要求</span>
            <el-select v-model="fromDate.specialRequirementsArr" multiple filterable placeholder="请选择" @change="setSpecial">
              <el-checkbox v-model="checked4" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll4">全选</el-checkbox>
              <el-option v-for="item in specialRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">其他要求</span>
            <el-select v-model="fromDate.otherRequirementsArr" multiple filterable placeholder="请选择" @change="setOther">
              <el-checkbox v-model="checked5" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll5">全选</el-checkbox>
              <el-option v-for="item in otherRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">外加剂要求</span>
            <el-select v-model="fromDate.admixtureRequirementsArr" multiple filterable placeholder="请选择" @change="setAdmixture">
              <el-checkbox v-model="checked6" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll6">全选</el-checkbox>
              <el-option v-for="item in admixtureRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="mixTime">
            <span slot="label" style="color: #ff0000">搅拌时间 </span>
            <el-input v-model="fromDate.mixTime" type="number" placeholder="请输入">
              <template slot="append"> s</template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">复用配合比库</span>
            <span style="color: #ff0000" @click="chooseMix">请选择</span>
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-top: 20px">
        <div>
          <el-button size="small" class="bottom_all" style="margin-bottom: 20px" @click="addItem(), (this.rawDialog = true)">添加</el-button>
        </div>
        <div>
          <el-table
            :key="tableKey"
            :header-cell-style="{ background: '#f3f6f9' }"
            :cell-style="{ borderRight: 'none' }"
            border
            style="width: 100%"
            class="options_table"
            :data="tableDataList"
            tooltip-effect="dark"
            highlight-current-row
            row-key="name"
            :row-class-name="rowClassName"
          >
            <template v-for="(item, index2) in tableList">
              <el-table-column v-if="(item.label == '对外仓' || item.label == '对外量(kg/m³)') ? isMixOut : item.status" :key="index2" :label="item.label" align="center" :min-width="item.width" :fixed="item.fixed" :prop="item.prop" :class-name="sortClass" :sortable="item.sortable">
                <template slot-scope="scope">
                  <div v-if="item.label == '理论用量(kg/m³)' && scope.row.name != '容重' && scope.row.name != '胶凝材料'">
                    <!-- <el-input v-model="scope.row.theoreValue" style="width: 150px" @input="handleInput(scope.row.theoreValue)" 
    oninput="if(scope.row.theoreValue === '0') { scope.row.theoreValue = ''; } else { scope.row.theoreValue=scope.row.theoreValue.replace(/^0+(\.\d+)?$/, ''); }"
    onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))" /> -->
                    <!-- <el-input v-model="scope.row.theoreValue" style="width: 150px"  onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))" @input="handleInput(scope.row.theoreValue),scope.row.theoreValue = scope.row.theoreValue.replace(/^(0+)|[^\d]+/g, '')" /> -->
                    <el-input
                      v-model="scope.row.theoreValue"
                      style="width: 150px"
                      onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      @focus="disableDrag"
                      @input="scope.row.theoreValue = $regExp.checkNum(scope.row.theoreValue);"
                        @blur="(scope.row.theoreValue = $regExp.blurCheckNum(scope.row.theoreValue)),setbleDrag()"
                    />
                  </div>
                  <div v-else-if="item.label == '理论用量(kg/m³)' && (scope.row.name == '容重' || scope.row.name == '胶凝材料')">
                    <el-input v-model="scope.row.theoreValue" disabled style="width: 150px" @focus="disableDrag" @blur="setbleDrag" />
                  </div>
                  <div v-else-if="item.label == '原物料'">
                    <span v-if="scope.row.name != '容重' && scope.row.name != '胶凝材料'" @click="chooseRaw(false, scope.$index)">{{ scope.row.name }}</span>
                    <span v-if="scope.row.name != '容重' && scope.row.name != '胶凝材料' && scope.row.name == ''" style="color: red" @click="chooseRaw(true, '')">请选择</span>
                    <span v-if="scope.row.name == '容重' || scope.row.name == '胶凝材料'">{{ scope.row.name }}</span>
                  </div>
                  <div v-else-if="item.label == '偏差(kg)' && scope.row.name !== '胶凝材料'">
                    <el-input v-model="scope.row.deviation" style="width: 150px" oninput="value=value.replace(/^0+(\d+)/g,'$1').replace(/[^\d]/g,'')"  @input="scope.row.deviation = $regExp.checkNum(scope.row.deviation)"
                        @blur="scope.row.deviation = $regExp.blurCheckNum(scope.row.deviation)" />
                  </div>
                  <div v-else-if="item.label == '对外量(kg/m³)'">
                      <el-input v-if="scope.row.name != '容重' && scope.row.name != '胶凝材料'"
                        v-model="scope.row.theoreValueTrueOut" style="width: 120px"
                        onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                        oninput="value=value.replace(/[^0-9.]/g,'')" @focus="disableDrag"
                        @input="$set(scope.row,'theoreValueTrueOut',$regExp.checkNum(scope.row.theoreValueTrueOut))"
                        @blur="$set(scope.row,'theoreValueTrueOut',$regExp.blurCheckNum(scope.row.theoreValueTrueOut)), setbleDrag()" />
                      <el-input v-else v-model="scope.row.theoreValueTrueOut" style="width: 120px" disabled
                        oninput="value=value.replace(/[^0-9.]/g,'')" />
                    </div>
                    <!-- <div v-else-if="item.label == '对外仓' && scope.row.name != '容重' && scope.row.name != '胶凝材料'">
                      <el-select :key="scope.$index" v-model="scope.row.rawFormCodeOut"
                        style="width: 120px" placeholder="请选择">
                        <el-option v-for="(item,index) in warehouseBindList" :key="item.useCode+scope.$index+index" :label="item.useAliasName"
                          :value="item.useCode"> </el-option>
                      </el-select>
                    </div> -->
                  <div v-else-if="item.label == '操作' && scope.row.name != '容重' && scope.row.name != '胶凝材料'">
                    <el-link :underline="false" type="danger" style="margin: 5px 0" @click="deleteItem(scope.$index)">删除</el-link>
                  </div>
                  <span v-else>{{ scope.row[item.prop] || "-" }}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetRawFromDate()">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="pagessubmitFromDate()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 使用仓库存仓绑定 -->
    <el-dialog v-dialogDrag :visible.sync="warehouseBindDig" width="900px" :close-on-click-modal="false" :before-close="resetOtherFromDate">
      <span slot="title" class="dialog-title">使用仓绑定</span>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="warehouseBindList" tooltip-effect="dark" height="500">
          <el-table-column label="库存仓" align="center" prop="warehouseId">
            <template slot-scope="scope">
              <el-select v-model="scope.row.warehouseId" disabled style="width: 100%" placeholder="请选择">
                <el-option v-for="(item, index) in warehouseList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="使用仓" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.useCode" disabled style="width: 100%" placeholder="请选择">
                <el-option v-for="(item, index) in usewarehouseList" :key="index" :label="item.fixedName" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="使用仓生产线" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.useLineId" disabled style="width: 100%" placeholder="请选择">
                <el-option v-for="(item, index) in lineList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="使用仓重命名" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.useAliasName" style="width: 100%" placeholder="请输入" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="排序号" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.sortNum" style="width: 100%" type="number" placeholder="请输入" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="工控材料名称" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.rawName" style="width: 100%" placeholder="请输入" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="工控材料规格" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specification" style="width: 100%" placeholder="请输入" clearable></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetOtherFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveusewarehouseBind">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 选择原物料 -->
    <rawChoose ref="rawChoose" :stationId.sync="fromDate.stationId" :isChooseRawDialog.sync="isChooseRaw" :isUpdate.sync="isUpdateType" :isRawIndex.sync="rawIndex" @selectRaw="selectRaw" />
    <!-- 复合配合比 -->
    <mixRawAgain ref="mixRawAgain" :lookRawDialog.sync="lookRaw" :isShowType.sync="showType" :isMixOut.sync="isMixOut" :warehouseBindList.sync="warehouseBindList" @selectRawDetail="selectRawDetail" />
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryMix, saveMix } from "@/api/basicConfig/mixForm.js";
import { getUserAutList } from "@/api/common.js";
import { getLists } from "@/api/smart/schedul/c.js";
import rawChoose from "./components/rawChoose.vue";
import mixRawAgain from "./components/mixRawAgain.vue";
import { compareArrays } from "@/utils/utils";
import { getUserInfo } from "@/utils/auth";
import {
  queryProcesses,
} from "@/api/basicConfig/proflow.js";
import {
  warehousePage,
  wareusehousePage,
  getPLByStationId,
  queryWarehouseUse,
  updateWarehouseUse
} from "@/api/basicConfig/site.js";

export default {
  components: {
    rawChoose,
    mixRawAgain,
  },
  mixins: [mixin],
  
  data() {
    return {
      /*表格增删改查及下载接口*/
      /*表格数据*/
      pagesType: 0,
      fromDate: {
        // 强度等级
        strengthGradeArr: [],
        strengthGradece: [],
        strengthGrade: "",
        strengthGradeId: "",
        // 性能等级
        performanceRateArr: [],
        performanceRate: [],
        performanceRequest: "",
        // 材料要求
        materialRequirementsArr: [],
        materialRequirements: [],
        materialRequest: "",
        // 特殊要求
        specialRequirementsArr: [],
        specialRequirements: [],
        specialRequest: "",
        // 其他要求
        otherRequirementsArr: [],
        otherRequirements: [],
        otherRequest: "",
        // 外加剂要求
        admixtureRequirementsArr: [],
        admixtureRequirements: [],
        additiveRequest: "",
        stationName: "",
        name: "",
        mixTime: "",
        mixInfo: "", //配合比信息
        UserInfo: "",
      },
      UserInfo: "",
      total: 0,
      selectRow: [],
      //  选择原物料
      isChooseRaw: false,
      isUpdateType: false,
      rawIndex: 0,
      lookRaw: false,
      showType: false,
      // 添加
      addDialog: false,
      addDialogTitle: "",
      tableList: [
        { label: "原物料", width: "160", prop: "name", status: true, sortable: false },
        { label: "理论用量(kg/m³)", width: "120", prop: "theoreValue", status: true, sortable: false },
        { label: "偏差(kg)", width: "120", prop: "deviation", status: true, sortable: false },
        { label: "对外量(kg/m³)", width: "100", prop: "theoreValueTrueOut", status: true, sortable: false },
        // { label: "对外仓", width: "120", prop: "rawFormCodeOut", status: true, sortable: false },
        { label: "操作", width: "auto", prop: "", status: true, sortable: false, },
      ],
      tableDataList: [{ id: "", name: "容重", theoreValue: "", deviation: "" ,theoreValueTrueOut: "", rawFormCodeOut: "",}],
      stationIdlist: [],
      //   多选下拉
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      strengthGradeList: [], //强度list
      performanceGradeList: [], //性能等级list
      materialRequirementsList: [], //材料要求list
      specialRequirementsList: [], //特殊要求list
      otherRequirementsList: [], // 其他要求list
      admixtureRequirementsList: [], //外加剂要求list
      rawDialog: false,
      /*表格数据*/
      table: [
        { label: "配合比名称", width: "auto", prop: "name", status: true, fixed: "left", sortable: false },
        { label: "产品名称", width: "auto", prop: "productName", status: true, sortable: false },
        { label: "站点", width: "auto", prop: "stationName", status: true, sortable: false },
        { label: "搅拌时间", width: "150", prop: "mixTime", status: true, sortable: false },
        { label: "操作", width: "180", prop: "", status: true, sortable: false, fixed: "right" },
      ],
      rules: {
        name: [{ required: true, message: "请输入配合比名称", trigger: "blur" }],
        stationId: [{ required: true, message: "请选择站点", trigger: "change" }],
        mixTime: [{ required: true, message: "请输入搅拌时间", trigger: "blur" }],
        strengthGradeId: [{ required: true, message: "请选择强度等级", trigger: "change" }],
      },
      rules2: {
        theoreValue: [{ required: true, message: "理论用量不能为空", trigger: "blur" }],
      },
      sortClass: "allowDrag",
      tableKey: false,
      usewarehouseList:[],
      warehouseList:[],
      lineList:[],
      warehouseBindList:[],
      warehouseBindDig:false,
      isMixOut:false,
    };
  },
  async created() {
    /*存储拷贝的原初始化fromDate数据*/
    getLists().then(res => {
      res.data.forEach(item => {
        if (!item) return;
        if (item.typeName == "强度等级") {
          this.strengthGradeList = item.list;
        } else if (item.typeName == "规范性能等级") {
          this.performanceGradeList = item.list;
        } else if (item.typeName == "材料要求") {
          this.materialRequirementsList = item.list;
        } else if (item.typeName == "特殊要求") {
          this.specialRequirementsList = item.list;
        } else if (item.typeName == "外加剂要求") {
          this.admixtureRequirementsList = item.list;
        } else if (item.typeName == "其他要求") {
          this.otherRequirementsList = item.list;
        }
      });
    });
    this.UserInfo = await getUserInfo();
    this.stationIdlist = await getUserAutList(true);

    this.tableParam = { ...this.tableParam, name: "", productNamelike: "", enable: 1, stationId: "" };
    if (this.UserInfo.pointIds.length > 0) {
      this.tableParam.stationId = this.UserInfo.pointIds[0];
    } else {
      this.tableParam.stationId = this.stationIdlist[0].id;
    }
    this.initData();
  },
  watch: {
    tableDataList: {
      handler(newValue) {
        let theoreValueJs = 0;
        let theoreValueTrueJs = 0;
        let theoreValueTrueOutJs = 0;
        newValue.forEach(item => {
          if (item.name.indexOf("水泥") !== -1 || item.name.indexOf("煤灰") !== -1 || item.name.indexOf("矿粉") !== -1 || item.name.indexOf("复合") !== -1 ) {
          // if (item.name.indexOf("水泥") !== -1 || item.name.indexOf("煤灰") !== -1 || item.name.indexOf("矿粉") !== -1 || item.name.indexOf("复合灰") !== -1 || item.name.indexOf("掺和料") !== -1) {
            theoreValueJs = theoreValueJs + item.theoreValue * 1;
            theoreValueTrueJs = theoreValueTrueJs + item.theoreValueTrue * 1;
            theoreValueTrueOutJs = theoreValueTrueOutJs + item.theoreValueTrueOut * 1;
          }
          if(item.name !== '容重' && item.name !== '胶凝材料') {
            this.handleInput(item.theoreValue)
          }
        });
        let obj = {
          name: "胶凝材料",
          theoreValue: theoreValueJs,
          theoreValueTrue: theoreValueTrueJs,
          theoreValueTrueOut: theoreValueTrueOutJs,
          deviation: "",
        };
        let index = this.tableDataList.findIndex(item2 => item2.name == "胶凝材料");
        if (index == -1) {
          this.tableDataList.push(obj);
        } else {
          this.$set(this.tableDataList[index], "theoreValue", Number(theoreValueJs).toFixed(2));
          this.$set(this.tableDataList[index], "theoreValueTrue", Number(theoreValueTrueJs).toFixed(2));
          this.$set(this.tableDataList[index], "theoreValueTrueOut", Number(theoreValueTrueOutJs).toFixed(2));
        }
        this.rowDrop();
      },
      deep: true,
    },
  },
  methods: {
    //获取站点工艺流程
   async getPointDetails() {
      let _this = this
      this.isMixOut = false
      queryProcesses({ stationId: this.fromDate.stationId }).then(res => {
        if (res.code === 1001) {
          const newData = JSON.parse(res.data.servicePoint).map(item => item.name);
          if(newData.findIndex(item => item == '工控对外配合比') !== -1) {
            _this.isMixOut = true
          }
        }
      });
      let res4 = await queryWarehouseUse({ stationId: this.fromDate.stationId });
      if (res4.code == 1001) {
        this.warehouseBindList = res4.data;
      }
    },
    //使用仓绑定 --开始
    resetOtherFromDate() {
      this.warehouseBindDig = false;
    },
    saveusewarehouseBind() {
      let type =false
      let typeIndex= 0
      this.warehouseBindList.forEach((item,index) => {
        if(!item.useAliasName){
          type =true
          typeIndex = index+1
        }
        let usewarehouseItem = this.usewarehouseList.find(item2 => item2.code == item.useCode)
        item['useName'] = usewarehouseItem.fixedName
        let lineItem = this.lineList.find(item3 => item3.id == item.useLineId)
        item['lineName'] = lineItem.name
      })
      if(type) {
        this.$message.warning(`第${typeIndex}行使用仓名称必填！`)
        return
      }
      let obj = {
        stationId: this.tableParam.stationId,
        useList: this.warehouseBindList,
      };
      updateWarehouseUse(obj).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功");
          this.warehouseBindDig = false;
        }
      });
    },
    //使用仓库存仓绑定/
    async warehouseBind() {
      if(!this.tableParam.stationId) {
        this.$message.warning('请先选择站点！')
        return
      }
      let res = await wareusehousePage({ stationId: this.tableParam.stationId });
      if (res.code == 1001) {
        this.usewarehouseList = res.data;
      }
      let res2 = await warehousePage({ stationId: this.tableParam.stationId });
      if (res2.code == 1001) {
        this.warehouseList = res2.data;
      }
      let res3 = await getPLByStationId({ stationId: this.tableParam.stationId });
      if (res3.code == 1001) {
        this.lineList = res3.data;
      }
      let res4 = await queryWarehouseUse({ stationId: this.tableParam.stationId });
      if (res4.code == 1001) {
        this.warehouseBindList = res4.data;
      }
      this.warehouseBindDig = true;
    },
    //使用仓绑定 --结束
    rowClassName(data) {
      if (data.rowIndex >= this.tableDataList.length - 1) {
        return "rowClassFilter";
      }
    },
    disableDrag() {
      console.log('disableDrag')
      this.sortClass = "";
    },
    setbleDrag() {
      console.log('setbleDrag')
      this.sortClass = "allowDrag";
    },
    rowDrop() {
      // 此时找到的元素是要拖拽元素的父容器
      const tbody = document.querySelector(`.options_table .el-table__body-wrapper tbody`);
      console.log(tbody);
      if (tbody) {
        this.$Sortable.create(tbody, {
          handle: ".allowDrag", // 格式为简单css选择器的字符串，使列表单元中符合选择器的元素成为拖动的手柄，只有按住拖动手柄才能使列表单元进行拖动
          draggable: ".el-table__row", // 允许拖拽的项目类名
          animation: 150, // ms, number 单位：ms，定义排序动画的时间
          filter: ".rowClassFilter", //过滤不可拖拽的元素
          onEnd: ({ newIndex, oldIndex }) => {
            const currRow = this.tableDataList.splice(oldIndex, 1)[0];
            this.tableDataList.splice(newIndex, 0, currRow);
          },
          onMove(e) {
            return e.related.className.indexOf("rowClassFilter") === -1;
          },
        });
      }
    },
    handleSelectionChange(row) {
      this.selectRow = row;
    },
    updateFromDate(title, row) {
      this.addDialog = true;
      this.addDialogTitle = title;
      this.fromDate = row;
      this.getPointDetails();
      // this.fromDate.strengthGradeArr = JSON.parse(this.fromDate.strengthGrade)?.map(v => v.id); //强度等级
      this.fromDate.performanceRateArr = this.fromDate.performanceRequest ? JSON.parse(this.fromDate.performanceRequest)?.map(v => v.id) : ""; //强度等级
      this.fromDate.materialRequirementsArr = this.fromDate.materialRequest ? JSON.parse(this.fromDate.materialRequest)?.map(v => v.id) : ""; //强度等级
      this.fromDate.specialRequirementsArr = this.fromDate.specialRequest ? JSON.parse(this.fromDate.specialRequest)?.map(v => v.id) : ""; //强度等级
      this.fromDate.otherRequirementsArr = this.fromDate.otherRequest ? JSON.parse(this.fromDate.otherRequest)?.map(v => v.id) : ""; //强度等级
      this.fromDate.admixtureRequirementsArr = this.fromDate.additiveRequest ? JSON.parse(this.fromDate.additiveRequest)?.map(v => v.id) : ""; //强度等级
      if (this.fromDate.performanceRequest) {
        this.fromDate.performanceRate = JSON.parse(this.fromDate.performanceRequest); //强度等级
      } else {
        this.fromDate.performanceRate = [];
      }
      if (this.fromDate.materialRequest) {
        this.fromDate.materialRequirements = JSON.parse(this.fromDate.materialRequest);
      } else {
        this.fromDate.materialRequirements = [];
      }
      if (this.fromDate.specialRequest) {
        this.fromDate.specialRequirements = JSON.parse(this.fromDate.specialRequest);
      } else {
        this.fromDate.specialRequirements = [];
      }
      if (this.fromDate.otherRequest) {
        this.fromDate.otherRequirements = JSON.parse(this.fromDate.otherRequest);
      } else {
        this.fromDate.otherRequirements = [];
      }
      if (this.fromDate.additiveRequest) {
        this.fromDate.admixtureRequirements = JSON.parse(this.fromDate.additiveRequest);
      } else {
        this.fromDate.admixtureRequirements = [];
      }
      console.log(this.fromDate);
      // this.fromDate.materialRequirements = JSON.parse(this.fromDate.materialRequest); //强度等级
      // this.fromDate.specialRequirements = JSON.parse(this.fromDate.specialRequest); //强度等级
      // this.fromDate.otherRequirements = JSON.parse(this.fromDate.otherRequest); //强度等级
      // this.fromDate.admixtureRequirements = JSON.parse(this.fromDate.additiveRequest); //强度等级
      this.tableDataList = JSON.parse(this.fromDate.mixInfo);
      let isRz = this.tableDataList.findIndex(item => item.name == '容重')
      if(isRz == -1) {
        this.tableDataList.push({ id: "", name: "容重", theoreValue: "", deviation: "",theoreValueTrueOut: "", rawFormCodeOut: "", })
        this.getSummaries();
      }
      this.tableKey = !this.tableKey;
      setTimeout(() => {
        this.rowDrop();
      }, 500);
    },
    updateStatus(row, status) {
      row.enable = status;
      saveMix(row).then(res => {
        if (res.code === 1001) {
          this.$message({
            message: "操作成功！",
            type: "success",
          });
          this.addDialog = false;
          this.initData();
        } else {
          this.$message({
            message: res.codeMsg,
            type: "warning",
          });
        }
      });
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam.productNamelike = "";
      this.tableParam.name = "";
      this.tableParam.stationId = "";
      this.tableParam.enable = 1;
      if (this.UserInfo.pointIds.length > 0) {
        this.tableParam.stationId = this.UserInfo.pointIds[0];
      } else {
        this.tableParam.stationId = this.stationIdlist[0].id;
      }
      this.initData();
    },
    initData() {
      if (!this.tableParam.stationId) {
        this.$message.warning("请选择站点！");
        return;
      }
      queryMix({ ...this.tableParam }).then(res => {
        if (res.code === 1001) {
          this.tableData = res.data.data;
          this.total = res.data.totalRows;
        }
      });

      this.tableDataList = [{ id: "", name: "容重", theoreValue: "", deviation: "",theoreValueTrueOut: "", rawFormCodeOut: "", }];
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.initData();
    },
    handleInput(val) {
      val = Number(val)
      if (val || val == 0) {
        this.getSummaries();
      } else {
        this.$message({
            type: "warning",
            message: `理论用量不可以为空`,
          });
      }
    },
    getSummaries() {
      var array = this.tableDataList.filter(item => item.name !== "容重" && item.name !== "胶凝材料");
      let array1 = 0
      let array2 = 0
      array1 = array.map(item => parseFloat(item.theoreValue));
      array2 = array.map(item => parseFloat(item.theoreValueTrueOut));
      let sum1 = Number(array1.reduce((accumulator, current) => accumulator + current, 0)).toFixed(2);
      let sum2 = Number(array2.reduce((accumulator, current) => accumulator + current, 0)).toFixed(2);
      this.tableDataList.forEach(item => {
        if (item.name === "容重") {
          item.theoreValue = sum1; //
          item.theoreValueTrueOut = sum2; //
        }
      });
    },
    setStrength(item) {
      // this.fromDate.strengthGradece.push(item);
      this.fromDate.strengthGrade = item.name;
      this.$forceUpdate();
    },
    setPerform() {
      let that = this;
      this.$nextTick(() => {
        this.fromDate.performanceRate = that.fromDate.performanceRateArr.map(item => {
          let obj = that.performanceGradeList.find(item2 => item2.id == item);
          return obj;
        });
        this.$forceUpdate();
      });
    },
    setMaterial() {
      this.$nextTick(() => {
        let that = this;
        this.$nextTick(() => {
          this.fromDate.materialRequirements = that.fromDate.materialRequirementsArr.map(item => {
            let obj = that.materialRequirementsList.find(item2 => item2.id == item);
            return obj || [];
          });
          this.$forceUpdate();
          console.log(this.fromDate.materialRequirements);
        });
      });
    },
    setSpecial() {
      this.$nextTick(() => {
        let that = this;
        this.$nextTick(() => {
          this.fromDate.specialRequirements = that.fromDate.specialRequirementsArr.map(item => {
            let obj = that.specialRequirementsList.find(item2 => item2.id == item);
            return obj;
          });
          this.$forceUpdate();
        });
      });
    },
    setOther() {
      this.$nextTick(() => {
        let that = this;
        this.$nextTick(() => {
          this.fromDate.otherRequirements = that.fromDate.otherRequirementsArr.map(item => {
            let obj = that.otherRequirementsList.find(item2 => item2.id == item);
            return obj;
          });
          this.$forceUpdate();
        });
      });
    },
    setAdmixture() {
      let that = this;
      this.$nextTick(() => {
        this.fromDate.admixtureRequirements = that.fromDate.admixtureRequirementsArr.map(item => {
          let obj = that.admixtureRequirementsList.find(item2 => item2.id == item);
          return obj;
        });
        this.$forceUpdate();
      });
    },
    selectAll2() {
      if (this.checked2) {
        this.fromDate.performanceRateArr = this.performanceGradeList.map(item => item.id);
        this.fromDate.performanceRate = this.performanceGradeList;
      } else {
        this.fromDate.performanceRateArr = [];
        this.fromDate.performanceRate = [];
      }
    },
    selectAll3() {
      if (this.checked3) {
        this.fromDate.materialRequirementsArr = this.materialRequirementsList.map(item => item.id);
        this.fromDate.materialRequirements = this.materialRequirementsList;
      } else {
        this.fromDate.materialRequirementsArr = [];
        this.fromDate.materialRequirements = [];
      }
    },
    selectAll4() {
      if (this.checked4) {
        this.fromDate.specialRequirementsArr = this.specialRequirementsList.map(item => item.id);
        this.fromDate.specialRequirements = this.specialRequirementsList;
      } else {
        this.fromDate.specialRequirementsArr = [];
        this.fromDate.specialRequirements = [];
      }
    },
    selectAll5() {
      if (this.checked5) {
        this.fromDate.otherRequirementsArr = this.otherRequirementsList.map(item => item.id);
        this.fromDate.otherRequirements = this.otherRequirementsList;
      } else {
        this.fromDate.otherRequirementsArr = [];
        this.fromDate.otherRequirements = [];
      }
    },
    selectAll6() {
      if (this.checked6) {
        this.fromDate.admixtureRequirementsArr = this.admixtureRequirementsList.map(item => item.id);
        this.fromDate.admixtureRequirements = this.admixtureRequirementsList;
      } else {
        this.fromDate.admixtureRequirementsArr = [];
        this.fromDate.admixtureRequirements = [];
      }
    },
    chooseMix() {
      this.$nextTick(() => {
        if (!this.fromDate.stationId) {
          this.$message.warning("请先选择站点！");
          return;
        }
        this.$refs.mixRawAgain.addClick(this.fromDate.stationId);
        this.lookRaw = true;
        this.showType = false;
      });
    },
    chooseRaw(type, index) {
      this.isUpdateType = type;
      this.rawIndex = index;
      this.isChooseRaw = true;
      this.$refs.rawChoose.addClick();
    },
    addItem() {
      if(!this.fromDate.stationId) {
        this.$message.warning('请先选择站点！')
        return
      }
      this.chooseRaw(true, "");
    },
    deleteItem(index) {
      this.tableDataList.splice(index, 1);
      this.getSummaries();
    },
    resetRawFromDate() {
      this.addDialog = false;
      this.isMixOut = false;
      this.tableDataList = [{ id: "", name: "容重", theoreValue: "", deviation: "",theoreValueTrueOut: "", rawFormCodeOut: "", }];
    },
    pagessubmitFromDate() {
      this.$refs["reffromDate"].validate(valid => {
        if (valid) {
          if (this.fromDate.mixTime == null || this.fromDate.mixTime === "" || this.fromDate.mixTime == 0) {
            this.$message.warning('搅拌时间必须大于0!')
            return;
          }
                // this.fromDate.strengthGradeId = JSON.stringify(this.fromDate.strengthGradeArr)
      // this.fromDate.strengthGrade = JSON.stringify(this.fromDate.strengthGradece);
      var isNullType = false;
      let namesJoined1 = "";
      let namesJoined2 = "";
      let namesJoined3 = "";
      let namesJoined4 = "";
      let namesJoined5 = "";
      if (this.fromDate.performanceRate?.length > 0) {
        this.fromDate.performanceRequest = JSON.stringify(this.fromDate.performanceRate);
        const filteredNames = this.fromDate.performanceRate.filter(item => item.name !== "无");
        if (filteredNames.length > 0) {
          namesJoined1 = filteredNames.map(item => item.name).join("-");
        }
        // namesJoined1 = this.fromDate.performanceRate.map(item => item.name).join("-");
      } else {
        this.fromDate.performanceRequest = "";
      }
      if (this.fromDate.materialRequirements?.length > 0) {
        this.fromDate.materialRequest = JSON.stringify(this.fromDate.materialRequirements);
        const filteredNames = this.fromDate.materialRequirements.filter(item => item.name !== "无");
        if (filteredNames.length > 0) {
          namesJoined2 = filteredNames.map(item => item.name).join("-");
        }
        // namesJoined2 = this.fromDate.materialRequirements.map(item => item.name).join("-");
      } else {
        this.fromDate.materialRequest = "";
      }
      if (this.fromDate.specialRequirements?.length > 0) {
        this.fromDate.specialRequest = JSON.stringify(this.fromDate.specialRequirements);
        const filteredNames = this.fromDate.specialRequirements.filter(item => item.name !== "无");
        if (filteredNames.length > 0) {
          namesJoined3 = filteredNames.map(item => item.name).join("-");
        }
        // namesJoined3 = this.fromDate.specialRequirements.map(item => item.name).join("-");
      } else {
        this.fromDate.specialRequest = "";
      }
      if (this.fromDate.otherRequirements?.length > 0) {
        this.fromDate.otherRequest = JSON.stringify(this.fromDate.otherRequirements);
        const filteredNames = this.fromDate.otherRequirements.filter(item => item.name !== "无");
        if (filteredNames.length > 0) {
          namesJoined4 = filteredNames.map(item => item.name).join("-");
        }
        // namesJoined4 = this.fromDate.otherRequirements.map(item => item.name).join("-");
      } else {
        this.fromDate.otherRequest = "";
      }
      if (this.fromDate.admixtureRequirements?.length > 0) {
        this.fromDate.additiveRequest = JSON.stringify(this.fromDate.admixtureRequirements);
        // namesJoined5 = this.fromDate.admixtureRequirements.map(item => item.name).join("-");
        const filteredNames = this.fromDate.admixtureRequirements.filter(item => item.name !== "无");
        if (filteredNames.length > 0) {
          namesJoined5 = filteredNames.map(item => item.name).join("-");
        }
      } else {
        this.fromDate.additiveRequest = "";
      }
      console.log(isNullType, 1);
      console.log(this.tableDataList);
      if (this.tableDataList.some(item => item.theoreValue === "")) {
        isNullType = true;
        console.log(isNullType, 2);
        if (isNullType == true) {
          this.$message({
            type: "warning",
            message: "理论用量不可以为空",
          });
        }
        return;
      }
      let dataArr = JSON.parse(JSON.stringify(this.tableDataList));
      dataArr.forEach(item => {
        item.rawFormCodeOut = ''
      })
      let index = dataArr.findIndex(item => item.name == "胶凝材料");
      dataArr.splice(index, 1);
      this.fromDate.mixInfo = JSON.stringify(dataArr);
      this.fromDate.productName = this.fromDate.strengthGrade;
      if (namesJoined1) {
        this.fromDate.productName += namesJoined1;
      }
      if (namesJoined2) {
        this.fromDate.productName += namesJoined2;
      }
      if (namesJoined3) {
        this.fromDate.productName += namesJoined3;
      }
      if (namesJoined4) {
        this.fromDate.productName += namesJoined4;
      }
      if (namesJoined5) {
        this.fromDate.productName += namesJoined5;
      }
      // this.fromDate.productName = this.fromDate.strengthGrade + "-" + namesJoined1 + "-" + namesJoined2 + "-" + namesJoined3 + "-" + namesJoined4 + "-" + namesJoined5;
          saveMix(this.fromDate).then(res => {
            if (res.code === 1001) {
              this.$message({
                message: "添加成功！",
                type: "success",
              });
              this.addDialog = false;
              this.initData();
            }
          });
        } else {
          return false;
        }
      });
    },
    /*选择原物料回调 */
    selectRaw(data, type, index) {
      if (compareArrays(data, this.tableDataList, "id")) {
        this.$message({ type: "warning", message: "存在重复添加的物品信息，请重新选择!" });
        return;
      } else {
        if (type) {
          this.tableDataList.unshift(data[0]);
          // this.tableDataList = data.concat(this.tableDataList);
        } else {
          // this.$set(item, "rawList", rawFormList);
          // this.tableDataList[index] = data[0]
          // this.$set(this.tableDataList, index, data[0]);
          this.tableDataList[index].name = data[0].name
          this.tableDataList[index].id = data[0].id
        }
        this.$forceUpdate();
        console.log(this.tableDataList);
      }
    },
    selectRawDetail(data) {
      this.tableDataList = data;
      this.tableKey = !this.tableKey;
      setTimeout(() => {
        this.rowDrop();
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
<style scoped>
::v-deep .el-table .cell {
  text-align: center;
}
::v-deep .sortable-chosen > td {
  /* 拖动的样式 */
  background-color: #eff2f6 !important;
  color: #409eff;
}
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  /* 修复拖拽的时候hover的不消失的问题 */
  background-color: #fff;
}
</style>